export const AppConfig = {};